import { markRaw } from 'vue'

export const state = {
  map: null,
  draw: null,
  mapReady: false,
  features: {
    type: 'FeatureCollection',
    features: []
  },
  feedFeatures: {
    type: 'FeatureCollection',
    features: []
  },
  featureSigs: [],
  featureCache: markRaw({}),
  featureCacheKey: null,
  featureFetchStamp: 0,

  orgLayers: [],

  currentFeature: null,
  currentFeatureChilds: null,

  page: 1,
  perPage: 10,

  planetFeaturesEnabled: false,
  beacons: [],

  tilesSettings: null,
  tilesMosaics: [],

  files: null,
  layers: null,
  reportTemplates: null,
  allTemplates: null,
  systemTemplatesLibrary: null,

  isFeatureCreated: false,
  totalOnMap: 0,

  // Heavy feature geometry cache - loaded on demand for features with >5000 points
  loadedHeavyGeometries: {},
  heavyFeatureLoading: {},

  // Feature visibility state - tracks which features are visible on map
  // Key: feature code, Value: boolean (true = visible, false = hidden)
  featureVisibility: {},
  
  // Resources state for media uploads
  resources: [],

  // Project-level filters (shared between feed and map)
  projectFilters: null,

  // Globally-driven feature popup (e.g. opened from a daily-review report link).
  // counter forces FeaturePopup to re-fetch even for the same feature.
  featurePopup: { feature: null, coordinates: null, counter: 0, visible: false },
}
